<template>
  <div class="art-guide-reorder-control-actions">
    <button class="action active" :disabled="disableSaving" type="button" @click="$emit('save')">Save</button>
    <button class="action" type="button" @click="$emit('close')">Cancel</button>
  </div>
</template>

<script>
export default {
  props: {
    disableSaving: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.art-guide-reorder-control-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: vars.$mobile-break-point + 1px) {
    flex-direction: row;
    gap: 24px;
    justify-content: center;
  }

  .action {
    display: block;
    width: 100%;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: vars.$c-dark-gray;
    border: 1px solid vars.$c-dark-gray;
    background-color: vars.$c-total-white;

    @media (min-width: vars.$mobile-break-point + 1px) {
      max-width: 180px;
    }

    &:not([disabled]) {
      &:hover {
        opacity: 0.7;
      }

      &.active {
        color: vars.$c-total-white;
        background-color: vars.$c-dark-gray;

        &:hover,
        &:focus {
          color: vars.$c-total-white !important;
        }
      }
    }

    &[disabled] {
      background-color: vars.$c-gray-da;
      border-color: vars.$c-gray-da;
      opacity: 0.7;
    }
  }
}
</style>
